package net.frozenbit.games.soundgame.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import net.frozenbit.games.soundgame.theme.Typography

@Composable
fun SoundNumberIndicator(
    modifier: Modifier = Modifier,
    number: Int,
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .background(
                color = Color(0xFFB78B5C),
                shape = CircleShape,
            )
            .size(20.dp)
    ) {
        Text(
            text = "$number",
            fontSize = 12.sp,
            fontFamily = Typography.audiowide(),
            color = Color(0xFFFFFBFB),
        )
    }
}